class Search {
  constructor() {
    this.init()
  }

  init () {
    this.cacheDOM()
    this.bindEvents()
  }

  cacheDOM () {
    this.$search_btn = $( "#search-btn-icon" )
    this.$search_form_close = $( "#search_form_close" )
  }

  bindEvents () {
    const _SELF = this

    this.$search_btn.on( 'click', ( event ) => {
      event.stopPropagation()
      $( '.search-form' ).addClass( 'active' ).find( 'input[type=text]' ).trigger( 'focus' )
      _SELF.$search_btn.addClass( 'd-none' )

    } )

    this.$search_form_close.on( 'click', ( e ) => {
      $( '.search-form' ).find( 'input[type=text]' ).val( '' ).trigger( 'keyup' )
      e.stopPropagation()
    } )

    $( 'body' ).on( 'click', function ( e ) {
      if ( window.innerWidth > 1200 ) {
        $( '.search-form' ).removeClass( 'active' )
        _SELF.$search_btn.removeClass( 'd-none' )
        _SELF.$search_form_close.addClass( 'd-none' )
      }
    } )

    $( '.search-form > input[type=text]' ).on( 'keyup', function ( e ) {
      if ( $( this ).val() ) {
        _SELF.$search_form_close.removeClass( 'd-none' )
      } else {
        _SELF.$search_form_close.addClass( 'd-none' )
      }
    } )
  }

  isMobile () {
    if ( window.innerWidth <= 1200 ) {
      return true
    } else {
      return false
    }
  }
}

new Search()
